// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@pub/img/loader.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    font-family: Roboto, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Ubuntu, 'Open Sans', 'Helvetica Neue', sans-serif, Tahoma;
    font-size: 15px;
}
p {
    padding: 7px 15px;
    font-weight: bold;
    border-radius: 5px;
    font-size: 16px;
}

.fixed-header {
    /*position: fixed;*/
    top: 0;
    width: 100%;
    margin: auto;
    z-index: 1000;
}

.ajax-loader {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 2000;
    background-color: #ffffff;
}
.ajax-loader > div {
    display: block;
    position: absolute;
    top: 50%; left: 50%;
    margin-top: -48px;
    margin-left: -48px;
    width: 96px; height: 96px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
}

.popup {
	position: fixed;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.35);
	padding: 20px;
	z-index: 1001;
	display: flex;
	justify-content: center;
	align-items: center;
}

.popup-content {
	background: #fff;
	width: 100%;
}

.telegram-modal-header {
	display: flex;
	align-items: center;
	height: 40px;
	padding: 0 15px;
}

.telegram-modal-body {
	padding: 0 15px;
	max-height: calc(100dvh - 120px);
	overflow: auto;
}

.telegram-modal-button {
	padding: 0 15px 15px 15px;
}

.ml-auto {
	margin-left: auto;
}

.notification-list {
    height: 538px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}

.block-departure {
    background-color: #f2dede;
    border-color: #a94442;
    color: #000000;  /*#a94442;*/
    font-weight: bold;
}
.block-fact-departure {
    background-color: #ebccd1;
    border-color: #ebccd1;
    color: #000000; /*#a94442;*/
    font-weight: bold;
}
.block-arrival {
    background-color: #d9edf7;
    border-color: #31708f;
    color: #000000; /*#31708f;*/
    font-weight: bold;
}
.block-fact-arrival {
    background-color: #bce8f1;
    border-color: #bce8f1;
    color: #000000; /*#31708f;*/
    font-weight: bold;
}

.text-info {
    color: rgb(52, 176, 226);
}

.text-danger {
    color: #ff0500;
}

.block-extra {
    background-color: #fcf8e3;
    border-color: #faebcc;
    color: #8a6d3b;
}

.bg-grey {
    background-color: #c0c0c0;
}
.bg-light {
    background-color: #E9E9E9;
}

.bg-red {
    background-color: #FAE1E2;
}
.bg-red-darken {
    background-color: #E6908D;
}


.bg-blue {
    background-color: #cae8f5;
}

.bg-turquoise {
    background-color: #5BC0DE;
}

.border-turquoise {
    border-color: #46B8DA !important;
}


.bg-white {
    background-color: white;
}

.bg-info .pull-left {
    max-width:  40%;
}

.bg-info .pull-left span {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}

.btn {
    white-space: normal;
    font-weight: bold;
}

.big-text {
    font-size: 21px;
    font-weight: bold;
    line-height: 1.4;
}
.small-text {
    font-size: 12px;
    font-weight: 300;
    line-height: 1.4;
}
.v-center {
    vertical-align: middle !important;
}
.text-bold {
    font-weight: 600;
}

.block-canceled {
    position: relative;
    left: 50%;
    top: -67px;
    opacity: .2;
}
.block-canceled:before, .block-canceled:after {
    position: absolute;
    content: ' ';
    height: 100px;
    width: 3px;
    background-color: #933;
}
.block-canceled:before {
    transform: rotate(75deg);
}
.block-canceled:after {
    transform: rotate(-75deg);
}

.signature-pad {
    text-align: center;
}

.conveyer-time {
    color: #000;
}

.conveyer-flight-link {
    text-align: center;
    display: block;
}

.conveyer-flight-link::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    height: 60px;
}

.conveyer-flight-link:hover::before {
    background-color: #d9edf7;
    opacity: 0.15;
    cursor: pointer;
}

.btn-change-tape {
    cursor: pointer;
    margin-right: 25px;
}

.btn-flight-time {
    width: 35%;
    margin: 60px auto 0;
    height: 90px;
    font-size: 25px;
}

.flight-canceled {
    position: relative;
}

.conveyer-flight-link .block-canceled {
    display: none;
}

.flight-canceled .block-canceled {
    display: block;
    left: 0;
    top: -28px;
}

#cameraFileInput, #cameraFileInputMenu {
    display: none;
}

#pictureFromCamera {
    width: 100%;
    height: auto;
    margin-top: 16px;
}

.camera {
    display: contents;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 700;
}

.modal-window {
    margin-top:-160px;
    height: auto;
    max-width: 400px;
    left: 40%;
}


@media (max-width: 400px) {
    .modal-window {
        margin-top:-80px;
        height: 156px;
        max-width: 400px;
        left: 5%;
    }
}

@media (max-width: 1200px) {
    .modal-window {
        margin-top:-160px;
        height: auto;
        max-width: 400px;
        left: 30%;
    }
}

.fixButton {
    /* width: 50px;*/
    /* height: 50px;  */
    border-radius: 50%;
    padding: 20px;
    /* background-color: #5bc0de; */
    border-width: 1px;
    border-color: gray;
    /* border-color: #46b8da; */
    position: fixed;
    float: left;
    right: 50%;
    margin-right: -36px;
    bottom: 7%;
    z-index: 100;
}

.disapear {
    display: none;
}

/* слой затемнения */
.dm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.65);
    overflow: auto;
    width: 100%;
    height: 100%;
    z-index: 9001;
}
/* активируем слой затемнения и модальное окно */
.dm-overlay:target {
    display: block;
    /* анимация и время задержки */
    -webkit-animation: fade .6s;
    -moz-animation: fade .6s;
    animation: fade .6s;
}
/* блочная таблица */
.dm-table {
    display: table;
    width: 100%;
    height: 100%;
}
/* ячейка блочной таблицы */
.dm-cell {
    display: table-cell;
    padding: 0 1em;
    vertical-align: middle;
    text-align: center;
}
/* модальный блок */
.dm-modal {
    display: inline-block;
    /* padding: 20px; */
    /* максимально возможная ширина */
    max-width: 50em;
    background: #fff;
    /* внешняя тень блока */
    -webkit-box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.22), 0px 19px 60px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.22), 0px 19px 60px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.22), 0px 19px 60px rgba(0, 0, 0, 0.3);
    color: #333;
    text-align: left;
    /* анимация и время задержки */
    -webkit-animation: fade .8s;
    -moz-animation: fade .8s;
    animation: fade .8s;
}

/* Сообщения */
.message-aria {
    margin-top: 10px;
    padding: 7px 12px;
    background: rgb(191, 255, 191);
    outline: 1px /*solid #000*/;
    border: 1px solid #fff;
    border-radius: 15px;
}

.message-unread {
    font-weight: bold;
    background: rgb(135, 255, 135);
    /* font-color: rgb(209, 239, 209); */
}
/*background: rgb(135, 255, 135);*/
.workPlaceType {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.dateTimerControl {
    display: flex;
    align-items: center;
}

.plus-btn, .minus-btn {
    border: 1px solid;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 38px;
    font-size: 20px;
    cursor: pointer;
}

.plus-btn {
    border-color: #21BA45;
    color:#21BA45;
    background-color: #E3F6E8;
}

.minus-btn {
    border-color: #DB2828;
    color: #DB2828;
    background-color: #FDDFDF;
}

.label {
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
}
.cpt-plane {
    width: 100%;
    height: 72px;
    background-color: #5BC0DE;
    border: 1px solid #46B8DA;
    color: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;
    padding: 12px 0;
    cursor: pointer;
    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}
.cpt-plane-active, .cpt-plane:hover {
    background-color: #31B0D5;
    border-color: #269ABC;
    box-shadow: 0px 3px 4px 0px #00000040 inset;
}
.loadsheet-body {
	padding: 12px 16px;
	display: flex;
	flex-direction: column;
	height: calc(100dvh - 128px);
}

.loadsheet-confirm-btn {
	margin-bottom: 10px;
	color: white;
	border: 1px solid transparent;
}

.bg-green {
	background-color: #44bb5e;
}

.bg-orange {
	background-color: #ff9900;
}

.bg-decline {
	background-color: #d93737;
}
.bg-confirm {
	background-color: #8bcb8b;
}
.bg-white {
	background-color: white;
}

.loadsheet-maintext {
	background-color: #fff;
	border: 1px solid #bbbbbb;
	border-radius: 5px;
	padding: 10px;
	flex: 1;
	overflow: auto;
	position: relative;
	display: flex;
}

.text {
	white-space: break-spaces;
	font-size: 8px;
	font-weight: 600;
	font-family: "Courier New";
}

.loadsheet-modal {
	padding: 20px;
	display: grid;
	place-content: center;
}

.loadsheet-confirmed {
	padding: 8px 0;
}

.loadsheet-confirmed-modal {
    background: white;
    max-width: 300px;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
}

.empty-loadsheet {
	height: calc(100dvh - 140px);
	display: grid;
	place-content: center;
	font-size: 20px;
	font-weight: 500;
	font-style: oblique;
	background-color: #e4e4e4;
	margin: 8px;
	border-radius: 8px;
}
.loadsheet-header {
	padding: 8px 16px;
	background-color: #f2dede;
	display: flex;
	gap: 1rem;
	align-items: center;
}
.hover-link:hover {
    text-decoration: underline;
}
.notification-btn:disabled {
    color: #c2c2c2 !important;
}

.modal-tabs {
  display: flex;
  justify-content: start;
  background-color: #269ABC;
  margin-inline: -15px;
}

.modal-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  position: relative;
  color: white;
  padding: 10px 20px;
  flex: 1 1 0;
  text-align: center;
}

.modal-tab.selected {
  background-color: rgba(255, 255, 255, 0.2);
}

.modal-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(233, 0, 0);
  color: white;
  border-radius: 50%;
  width: 18px;
  aspect-ratio: 1;
  font-size: 12px;
  line-height: 1;
}

.modal-btns {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modal-btn:focus {
  outline: none;
  box-shadow: none;
}
.modal-btn.disabled {
  filter: grayscale(1);
}
.note-text-header {
  font-size: 16px;
}
.read-all-btn {
  margin-top: 5px;
  text-align: center;
  padding: 8px;
  background-color: #5bc0de;
  color: #fff;
}

.notification-list {
  margin-top: 10px;
}

.fontsize-change-btn, .fullscreen-btn {
	z-index: 5;
}

.loadsheet-maintext .text.zoomed {
	transform-origin: left top;
}

.text-white {
    color: white! important;
}

.flight-menu-tabs .btn {
    border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./resources/style.css"],"names":[],"mappings":"AAAA;IACI,wIAAwI;IACxI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,QAAQ,EAAE,SAAS;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW,EAAE,YAAY;IACzB,6DAA+C;AACnD;;AAEA;CACC,eAAe;CACf,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,qCAAqC;CACrC,aAAa;CACb,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc,GAAG,WAAW;IAC5B,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc,EAAE,WAAW;IAC3B,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc,EAAE,WAAW;IAC3B,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc,EAAE,WAAW;IAC3B,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,OAAO;IACP,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,SAAS;AACb;;;AAGA;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,gBAAgB;QAChB,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;QACZ,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,+BAA+B;IAC/B,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;AACA,gDAAgD;AAChD;IACI,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;AACvB;AACA,oBAAoB;AACpB;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;AACA,2BAA2B;AAC3B;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;AACA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,uFAAuF;IACvF,oFAAoF;IACpF,+EAA+E;IAC/E,WAAW;IACX,gBAAgB;IAChB,8BAA8B;IAC9B,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,oCAAoC;AACxC;AACA,kCAAkC;AAClC;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oFAAoF;AACxF;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2CAA2C;AAC/C;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,OAAO;CACP,cAAc;CACd,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;CACC,4BAA4B;CAC5B,aAAa;CACb,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,yBAAyB;CACzB,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,SAAS;CACT,mBAAmB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["body, html {\r\n    font-family: Roboto, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Ubuntu, 'Open Sans', 'Helvetica Neue', sans-serif, Tahoma;\r\n    font-size: 15px;\r\n}\r\np {\r\n    padding: 7px 15px;\r\n    font-weight: bold;\r\n    border-radius: 5px;\r\n    font-size: 16px;\r\n}\r\n\r\n.fixed-header {\r\n    /*position: fixed;*/\r\n    top: 0;\r\n    width: 100%;\r\n    margin: auto;\r\n    z-index: 1000;\r\n}\r\n\r\n.ajax-loader {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    opacity: .4;\r\n    z-index: 2000;\r\n    background-color: #ffffff;\r\n}\r\n.ajax-loader > div {\r\n    display: block;\r\n    position: absolute;\r\n    top: 50%; left: 50%;\r\n    margin-top: -48px;\r\n    margin-left: -48px;\r\n    width: 96px; height: 96px;\r\n    background: url(~@pub/img/loader.gif) no-repeat;\r\n}\r\n\r\n.popup {\r\n\tposition: fixed;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\tbackground-color: rgba(0, 0, 0, 0.35);\r\n\tpadding: 20px;\r\n\tz-index: 1001;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.popup-content {\r\n\tbackground: #fff;\r\n\twidth: 100%;\r\n}\r\n\r\n.telegram-modal-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\theight: 40px;\r\n\tpadding: 0 15px;\r\n}\r\n\r\n.telegram-modal-body {\r\n\tpadding: 0 15px;\r\n\tmax-height: calc(100dvh - 120px);\r\n\toverflow: auto;\r\n}\r\n\r\n.telegram-modal-button {\r\n\tpadding: 0 15px 15px 15px;\r\n}\r\n\r\n.ml-auto {\r\n\tmargin-left: auto;\r\n}\r\n\r\n.notification-list {\r\n    height: 538px;\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.block-departure {\r\n    background-color: #f2dede;\r\n    border-color: #a94442;\r\n    color: #000000;  /*#a94442;*/\r\n    font-weight: bold;\r\n}\r\n.block-fact-departure {\r\n    background-color: #ebccd1;\r\n    border-color: #ebccd1;\r\n    color: #000000; /*#a94442;*/\r\n    font-weight: bold;\r\n}\r\n.block-arrival {\r\n    background-color: #d9edf7;\r\n    border-color: #31708f;\r\n    color: #000000; /*#31708f;*/\r\n    font-weight: bold;\r\n}\r\n.block-fact-arrival {\r\n    background-color: #bce8f1;\r\n    border-color: #bce8f1;\r\n    color: #000000; /*#31708f;*/\r\n    font-weight: bold;\r\n}\r\n\r\n.text-info {\r\n    color: rgb(52, 176, 226);\r\n}\r\n\r\n.text-danger {\r\n    color: #ff0500;\r\n}\r\n\r\n.block-extra {\r\n    background-color: #fcf8e3;\r\n    border-color: #faebcc;\r\n    color: #8a6d3b;\r\n}\r\n\r\n.bg-grey {\r\n    background-color: #c0c0c0;\r\n}\r\n.bg-light {\r\n    background-color: #E9E9E9;\r\n}\r\n\r\n.bg-red {\r\n    background-color: #FAE1E2;\r\n}\r\n.bg-red-darken {\r\n    background-color: #E6908D;\r\n}\r\n\r\n\r\n.bg-blue {\r\n    background-color: #cae8f5;\r\n}\r\n\r\n.bg-turquoise {\r\n    background-color: #5BC0DE;\r\n}\r\n\r\n.border-turquoise {\r\n    border-color: #46B8DA !important;\r\n}\r\n\r\n\r\n.bg-white {\r\n    background-color: white;\r\n}\r\n\r\n.bg-info .pull-left {\r\n    max-width:  40%;\r\n}\r\n\r\n.bg-info .pull-left span {\r\n    display: inline-block;\r\n    width: 100%;\r\n    white-space: nowrap;\r\n    overflow: hidden !important;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.btn {\r\n    white-space: normal;\r\n    font-weight: bold;\r\n}\r\n\r\n.big-text {\r\n    font-size: 21px;\r\n    font-weight: bold;\r\n    line-height: 1.4;\r\n}\r\n.small-text {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n    line-height: 1.4;\r\n}\r\n.v-center {\r\n    vertical-align: middle !important;\r\n}\r\n.text-bold {\r\n    font-weight: 600;\r\n}\r\n\r\n.block-canceled {\r\n    position: relative;\r\n    left: 50%;\r\n    top: -67px;\r\n    opacity: .2;\r\n}\r\n.block-canceled:before, .block-canceled:after {\r\n    position: absolute;\r\n    content: ' ';\r\n    height: 100px;\r\n    width: 3px;\r\n    background-color: #933;\r\n}\r\n.block-canceled:before {\r\n    transform: rotate(75deg);\r\n}\r\n.block-canceled:after {\r\n    transform: rotate(-75deg);\r\n}\r\n\r\n.signature-pad {\r\n    text-align: center;\r\n}\r\n\r\n.conveyer-time {\r\n    color: #000;\r\n}\r\n\r\n.conveyer-flight-link {\r\n    text-align: center;\r\n    display: block;\r\n}\r\n\r\n.conveyer-flight-link::before {\r\n    content: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 60px;\r\n}\r\n\r\n.conveyer-flight-link:hover::before {\r\n    background-color: #d9edf7;\r\n    opacity: 0.15;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-change-tape {\r\n    cursor: pointer;\r\n    margin-right: 25px;\r\n}\r\n\r\n.btn-flight-time {\r\n    width: 35%;\r\n    margin: 60px auto 0;\r\n    height: 90px;\r\n    font-size: 25px;\r\n}\r\n\r\n.flight-canceled {\r\n    position: relative;\r\n}\r\n\r\n.conveyer-flight-link .block-canceled {\r\n    display: none;\r\n}\r\n\r\n.flight-canceled .block-canceled {\r\n    display: block;\r\n    left: 0;\r\n    top: -28px;\r\n}\r\n\r\n#cameraFileInput, #cameraFileInputMenu {\r\n    display: none;\r\n}\r\n\r\n#pictureFromCamera {\r\n    width: 100%;\r\n    height: auto;\r\n    margin-top: 16px;\r\n}\r\n\r\n.camera {\r\n    display: contents;\r\n    max-width: 100%;\r\n    margin-bottom: 5px;\r\n    font-weight: 700;\r\n}\r\n\r\n.modal-window {\r\n    margin-top:-160px;\r\n    height: auto;\r\n    max-width: 400px;\r\n    left: 40%;\r\n}\r\n\r\n\r\n@media (max-width: 400px) {\r\n    .modal-window {\r\n        margin-top:-80px;\r\n        height: 156px;\r\n        max-width: 400px;\r\n        left: 5%;\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .modal-window {\r\n        margin-top:-160px;\r\n        height: auto;\r\n        max-width: 400px;\r\n        left: 30%;\r\n    }\r\n}\r\n\r\n.fixButton {\r\n    /* width: 50px;*/\r\n    /* height: 50px;  */\r\n    border-radius: 50%;\r\n    padding: 20px;\r\n    /* background-color: #5bc0de; */\r\n    border-width: 1px;\r\n    border-color: gray;\r\n    /* border-color: #46b8da; */\r\n    position: fixed;\r\n    float: left;\r\n    right: 50%;\r\n    margin-right: -36px;\r\n    bottom: 7%;\r\n    z-index: 100;\r\n}\r\n\r\n.disapear {\r\n    display: none;\r\n}\r\n\r\n/* слой затемнения */\r\n.dm-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    background: rgba(0, 0, 0, 0.65);\r\n    overflow: auto;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9001;\r\n}\r\n/* активируем слой затемнения и модальное окно */\r\n.dm-overlay:target {\r\n    display: block;\r\n    /* анимация и время задержки */\r\n    -webkit-animation: fade .6s;\r\n    -moz-animation: fade .6s;\r\n    animation: fade .6s;\r\n}\r\n/* блочная таблица */\r\n.dm-table {\r\n    display: table;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n/* ячейка блочной таблицы */\r\n.dm-cell {\r\n    display: table-cell;\r\n    padding: 0 1em;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n/* модальный блок */\r\n.dm-modal {\r\n    display: inline-block;\r\n    /* padding: 20px; */\r\n    /* максимально возможная ширина */\r\n    max-width: 50em;\r\n    background: #fff;\r\n    /* внешняя тень блока */\r\n    -webkit-box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.22), 0px 19px 60px rgba(0, 0, 0, 0.3);\r\n    -moz-box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.22), 0px 19px 60px rgba(0, 0, 0, 0.3);\r\n    box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.22), 0px 19px 60px rgba(0, 0, 0, 0.3);\r\n    color: #333;\r\n    text-align: left;\r\n    /* анимация и время задержки */\r\n    -webkit-animation: fade .8s;\r\n    -moz-animation: fade .8s;\r\n    animation: fade .8s;\r\n}\r\n\r\n/* Сообщения */\r\n.message-aria {\r\n    margin-top: 10px;\r\n    padding: 7px 12px;\r\n    background: rgb(191, 255, 191);\r\n    outline: 1px /*solid #000*/;\r\n    border: 1px solid #fff;\r\n    border-radius: 15px;\r\n}\r\n\r\n.message-unread {\r\n    font-weight: bold;\r\n    background: rgb(135, 255, 135);\r\n    /* font-color: rgb(209, 239, 209); */\r\n}\r\n/*background: rgb(135, 255, 135);*/\r\n.workPlaceType {\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    padding: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.dateTimerControl {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.plus-btn, .minus-btn {\r\n    border: 1px solid;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 48px;\r\n    height: 38px;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n\r\n.plus-btn {\r\n    border-color: #21BA45;\r\n    color:#21BA45;\r\n    background-color: #E3F6E8;\r\n}\r\n\r\n.minus-btn {\r\n    border-color: #DB2828;\r\n    color: #DB2828;\r\n    background-color: #FDDFDF;\r\n}\r\n\r\n.label {\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    font-weight: 700;\r\n}\r\n.cpt-plane {\r\n    width: 100%;\r\n    height: 72px;\r\n    background-color: #5BC0DE;\r\n    border: 1px solid #46B8DA;\r\n    color: #ffffff;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    border-radius: 4px;\r\n    padding: 12px 0;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n.cpt-plane-active, .cpt-plane:hover {\r\n    background-color: #31B0D5;\r\n    border-color: #269ABC;\r\n    box-shadow: 0px 3px 4px 0px #00000040 inset;\r\n}\r\n.loadsheet-body {\r\n\tpadding: 12px 16px;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\theight: calc(100dvh - 128px);\r\n}\r\n\r\n.loadsheet-confirm-btn {\r\n\tmargin-bottom: 10px;\r\n\tcolor: white;\r\n\tborder: 1px solid transparent;\r\n}\r\n\r\n.bg-green {\r\n\tbackground-color: #44bb5e;\r\n}\r\n\r\n.bg-orange {\r\n\tbackground-color: #ff9900;\r\n}\r\n\r\n.bg-decline {\r\n\tbackground-color: #d93737;\r\n}\r\n.bg-confirm {\r\n\tbackground-color: #8bcb8b;\r\n}\r\n.bg-white {\r\n\tbackground-color: white;\r\n}\r\n\r\n.loadsheet-maintext {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #bbbbbb;\r\n\tborder-radius: 5px;\r\n\tpadding: 10px;\r\n\tflex: 1;\r\n\toverflow: auto;\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n}\r\n\r\n.text {\r\n\twhite-space: break-spaces;\r\n\tfont-size: 8px;\r\n\tfont-weight: 600;\r\n\tfont-family: \"Courier New\";\r\n}\r\n\r\n.loadsheet-modal {\r\n\tpadding: 20px;\r\n\tdisplay: grid;\r\n\tplace-content: center;\r\n}\r\n\r\n.loadsheet-confirmed {\r\n\tpadding: 8px 0;\r\n}\r\n\r\n.loadsheet-confirmed-modal {\r\n    background: white;\r\n    max-width: 300px;\r\n    border-radius: 6px;\r\n    padding: 6px 12px;\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    text-align: center;\r\n}\r\n\r\n.empty-loadsheet {\r\n\theight: calc(100dvh - 140px);\r\n\tdisplay: grid;\r\n\tplace-content: center;\r\n\tfont-size: 20px;\r\n\tfont-weight: 500;\r\n\tfont-style: oblique;\r\n\tbackground-color: #e4e4e4;\r\n\tmargin: 8px;\r\n\tborder-radius: 8px;\r\n}\r\n.loadsheet-header {\r\n\tpadding: 8px 16px;\r\n\tbackground-color: #f2dede;\r\n\tdisplay: flex;\r\n\tgap: 1rem;\r\n\talign-items: center;\r\n}\r\n.hover-link:hover {\r\n    text-decoration: underline;\r\n}\r\n.notification-btn:disabled {\r\n    color: #c2c2c2 !important;\r\n}\r\n\r\n.modal-tabs {\r\n  display: flex;\r\n  justify-content: start;\r\n  background-color: #269ABC;\r\n  margin-inline: -15px;\r\n}\r\n\r\n.modal-tab {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  position: relative;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  flex: 1 1 0;\r\n  text-align: center;\r\n}\r\n\r\n.modal-tab.selected {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.modal-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: rgb(233, 0, 0);\r\n  color: white;\r\n  border-radius: 50%;\r\n  width: 18px;\r\n  aspect-ratio: 1;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n}\r\n\r\n.modal-btns {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n.modal-btn:focus {\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n.modal-btn.disabled {\r\n  filter: grayscale(1);\r\n}\r\n.note-text-header {\r\n  font-size: 16px;\r\n}\r\n.read-all-btn {\r\n  margin-top: 5px;\r\n  text-align: center;\r\n  padding: 8px;\r\n  background-color: #5bc0de;\r\n  color: #fff;\r\n}\r\n\r\n.notification-list {\r\n  margin-top: 10px;\r\n}\r\n\r\n.fontsize-change-btn, .fullscreen-btn {\r\n\tz-index: 5;\r\n}\r\n\r\n.loadsheet-maintext .text.zoomed {\r\n\ttransform-origin: left top;\r\n}\r\n\r\n.text-white {\r\n    color: white! important;\r\n}\r\n\r\n.flight-menu-tabs .btn {\r\n    border-radius: 0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
